<template>
  <div v-if="data.slug && data.name" class="mt-3">
    {{ $t('preview.relateds.groupers.moreFrom') }}
    <nuxt-link
      class="exp-font"
      :to="$urlBuilder(type, { slug: data.slug })"
      @click.native="$bvModal.hide('preview-vector-modal')"
    >
      {{ data.name }}
    </nuxt-link>
    {{ $t('preview.relateds.groupers.nicheSvgs') }}
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('experience', ['isDesignActive']),
    ...mapGetters('niches', ['getNichesName', 'getTopicsName']),
    type() {
      return this.isDesignActive ? this.getTopicsName : this.getNichesName;
    }
  }
};
</script>
